import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components/macro';
import { colourNeutral03 } from '../styling/colours';
import { spacing04, spacing05, spacing07 } from '../styling/spacing';
import { inputBorderWidth, inputSidePadding } from './form/inputs/inputStyles';
import { TextInput } from './TextInput';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  icon: React.ReactNode;
  className?: string;
};

export const TextInputWithIcon = ({ icon, className, ...props }: Props) => (
  <Container className={className}>
    {icon}
    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
    <TextInputPaddedToAllowSpaceForIcon {...(props as any)} />
  </Container>
);

const iconSize = spacing05;

const Container = styled.div`
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${spacing04};
    height: ${iconSize};
    width: ${iconSize};
    stroke: none;
    fill: ${colourNeutral03};
  }
`;

const paddingToAllowSpaceForIcon = spacing07;

const TextInputPaddedToAllowSpaceForIcon = styled(TextInput)`
  padding-left: ${paddingToAllowSpaceForIcon};
  width: calc(100% - ${paddingToAllowSpaceForIcon} - ${inputSidePadding} - ${inputBorderWidth} - ${inputBorderWidth});
`;
